
function Header() {
    return (
        <div className="hdr-container">
        <span className="header-text">NFB-CS Vs Code Intro/Overview</span>
        </div>
    );
}

export default Header;